import React from "react";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from "@mui/material";

export function ValidationError({ message }) {
    const classes = useStyles();
    return <Typography className={classes.root}>
        {message}
    </Typography>
}
const useStyles = makeStyles(() =>
    createStyles({
        root: {
            width: '100%',
            textAlign: 'left',
            color: "#dd2c23",
            fontSize: '0.75rem !important',
        },
    }),
);